import Meta from "@/vuex/models/meta";
import ExternalAccess from "@/vuex/models/external-access/external-access";

export default class ExternalAccessState {
  public requests: ExternalAccess[] = [];
  public meta!: Meta;
  public items: ExternalAccess[] = [];
}
